import type { LanguageInfo } from "../../common/records/LanguageInfo"

const langInfo: LanguageInfo = {
  id: "en",
  name: "English",
  displayName: "English",
  phone: "gb",
  email: "en",
  defaultCountry: "gb",
  api: "en",
  moment: "en-gb",
  jumio: "en_GB",
  nginx: "en",
  countriesTranslations: "EN",
  translations: "en",
  phraseApp: "en-US",
  canonical: "",
  hreflang: "en-US",
  iso: "en-US",
  locations: "en",
  dateFormat: "iii' 'd' 'LLL",
  dateFormatShort: "d'/'L",
  dateFormatLong: "dd'.'LL'.'yyyy",
  dateFormatPlain: "P",
  timeFormat: "p",
  durationFormat: "H[h] mm[m]",
  durationFormatShort: "m[m] ss[s]",
  dimension: "__x__ cm",
  weight: "__x__ kg",
  latinInputs: false,
  currency: "gbp",
  direction: "ltr",
  flag: "gb",
  fontSubsets: "greek,latin-ext",
  firstNamePlaceholder: "Harry James",
  lastNamePlaceholder: "Brown",
  addressPlaceholder: "71 Wall Stt",
  cityPlaceholder: "New York",
  zipCodePlaceholder: "10005",
  idNumberPlaceholder: "1234567890",
  companyVatPlaceholder: "10007",
  companyNamePlaceholder: "Kiwi.com",
  distanceUnit: "__x__ km",
  distanceUnitConversionRate: "1",
  elevioLang: "",
  specialFont: "",
  decimalSeparator: ".",
  thousandsSeparator: ",",
  separateFourDigits: "1",
}

export default langInfo
